import { render, staticRenderFns } from "./SMSContentSettings.vue?vue&type=template&id=191d5f82&scoped=true&"
import script from "./SMSContentSettings.vue?vue&type=script&lang=js&"
export * from "./SMSContentSettings.vue?vue&type=script&lang=js&"
import style0 from "./SMSContentSettings.vue?vue&type=style&index=0&id=191d5f82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191d5f82",
  null
  
)

export default component.exports